import { render, staticRenderFns } from "./CustomizeChoice.vue?vue&type=template&id=2f745145&"
import script from "./CustomizeChoice.vue?vue&type=script&lang=js&"
export * from "./CustomizeChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports